<template>
  <div
    class="bb-table-wrapper"
    id="board"
  >
    <vue-good-table
      :columns="headings"
      :fixed-header="false"
      :rows="spells"
      :search-options="{
        enabled: true,
        placeholder: 'search...',
      }"
      :pagination-options="{
        enabled: true,
        mode: 'records',
        perPage: 7,
        perPageDropdown: [7, 10, 20, 30, 40, 50],
        position: 'bottom',
        dropdownAllowAll: true,
        setCurrentPage: 1,
        nextLabel: 'next',
        prevLabel: 'prev',
        rowsPerPageLabel: 'Spells per page',
        ofLabel: 'of',
        allLabel: 'All',
      }"
      :row-style-class="rowStyleClassFn"
      v-on:cell-click="onCellClick"
      styleClass="vgt-table bordered"
      theme="black-rhino"
    >
      <template v-slot:table-row="props">
        <!-- no heading is blank label -->
        <span v-if="props.column.label == ''"> </span>

        <!-- flags -->
        <span
          v-if="
            props.column.field === 'progressive_image' ||
            props.column.field === 'triggered_image'
          "
        >
          <img
            :src="tickImg"
            :class="isVisible(props)"
            height="50"
            width="50"
            alt="tick image"
          />
        </span>

        <!-- row number -->
        <span v-if="props.column.field === 'rowNumber'">
          {{
            props.row.originalIndex !== undefined
              ? props.row.originalIndex + 1
              : props.index + 1
          }}
        </span>
        <span v-else>{{ props.formattedRow[props.column.field] }}</span>
      </template>

      <template #emptystate>*** No static spells ***</template>
    </vue-good-table>
  </div>
</template>

<script>
import 'vue-good-table-next/dist/vue-good-table-next.css'

import { VueGoodTable } from 'vue-good-table-next'
import { inject } from 'vue'

// import isEmpty from '../helpers/isEmpty'

import scrollTable from '../helpers/scrollTable'

import deleteImg from '../assets/images/bbDelete48.png'
import tickImg from '../assets/images/bbTick.png'

export default {
  name: 'TableSpellsStatic',
  emits: [
    'show-spell-static-panel',
    'refresh-scroll-state',
    'delete-static-spell',
  ],
  //==================================================================
  // components
  //------------
  components: {
    VueGoodTable,
  },
  //==================================================================
  // setup
  //-------
  setup() {
    const global = inject('global')
    return { global }
  },
  //==================================================================
  // props
  //-------
  props: {
    headings: {
      type: Array,
      required: true,
    },
    spells: {
      type: Array,
      required: true,
    },
    // character: {
    //   type: Object,
    //   required: true
    // },
  },
  //==================================================================
  // data
  //------
  data() {
    return {
      isDeletingClearTimer: null,
      //
      spells_array: [],
      //
      deleteImg,
      tickImg,
      //
      isDeleting: false,
    }
  },
  //====================================================================
  // methods
  //---------
  methods: {
    //==================================================================
    // is visible
    //------------
    isVisible(props) {
      if (
        (props.column.field == 'progressive_image' &&
          props.row['progressive'] == true) ||
        (props.column.field == 'triggered_image' &&
          props.row['triggered'] == true)
      ) {
        return 'bb-img-visible'
      }
      return 'bb-img-hidden'
    },
    //==================================================================
    // on cell click - open spell sheet
    //----------------------------------
    onCellClick(params) {
      // --------------------------------------------------------------
      // prevent cell click if deleting or clicking from action column
      // --------------------------------------------------------------
      if (this.isDeleting || params.column.field.substring(0, 6) == 'action') {
        return
      }
      // ------------------------
      // show static spell panel
      // ------------------------
      this.$emit('show-spell-static-panel', params.row)
    },
    //==================================================================
    // colour rows
    //-------------
    rowStyleClassFn(row) {
      if (row['integrated'] === false) {
        return 'rowInactiveSpell'
      }

      if (row.originalIndex % 2 === 0) {
        return 'rowNeutral'
      } else {
        return 'rowParty'
      }
    },
    //==================================================================
    // handle scroll table
    //---------------------
    handleScrollTable(dir) {
      scrollTable(document, dir)
    },
    //==================================================================
    // confirm deletion
    //------------------
    async confirmDeletion(row) {
      // -----------------------------------
      // prevent cell click whilst deleting
      // -----------------------------------
      this.isDeleting = true
      try {
        this.$emit('delete-static-spell', row)
      } finally {
        // -------------------------
        // clear any existing timer
        // -------------------------
        if (this.isDeletingClearTimer) clearTimeout(this.isDeletingClearTimer)
        // ----------------------------------
        // delay clearing isDeleting (300ms)
        // ----------------------------------
        this.isDeletingClearTimer = setTimeout(() => {
          this.isDeleting = false
          this.isDeletingClearTimer = null
        }, 300)
      }
    },
  },
  //==================================================================
  // before unmount
  //----------------
  beforeUnmount() {
    // ------------------------
    // clear any pending timer
    // ------------------------
    if (this.isDeletingClearTimer) {
      clearTimeout(this.isDeletingClearTimer)
      this.isDeletingClearTimer = null
    }
  },
}
</script>
